export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_16_15.Still003.b2135287.jpg";